
    import {Component, Vue} from 'vue-property-decorator';
    import InputText from '@/components/form/Input-text.vue';
    import Spinner from '@/components/spinner/Spinner.vue';

    @Component({
        components: {
            InputText,
            Spinner,
        },
    })

    export default class Login extends Vue {
        private email = '';
        private password = '';

        private onSubmit(e: any) {
            this.$validator.validate().then((valid) => {
                if (valid) {
                    this.sendLogin();
                }
            });

            e.preventDefault();
        }

        private async sendLogin() {
            const email = this.email;
            const password = this.password;
            this.$store.dispatch('login', {email, password})
                .then(() => {
                    this.$router.replace(<string>this.$route.query.redirect || '/');
                    this.$notify({group: 'auth', type: 'success', text: 'Boli ste prihlásený'});
                })
                .catch((err) => {
                    this.$notify({group: 'auth', type: 'error', text: 'Email alebo heslo nebolo spravne.'});
                });
        }
    }
